<template>
  <div>
    <div
      class="knowledge-test-title"
      data-test="summary-of-knowledge-test--title"
    >
      {{ $t('summart_of_knowledge_test.title') }}
    </div>
    <div class="section-white">
      <div class="image-wrapper">
        <img :src="`/static/img/img-sum-of-knowledge.png`">
      </div>
      <p
        class="risk-point"
        v-html="$t('summart_of_knowledge_test.user_risk_point', { knowledgeTestPoint })"
      />
      <p class="describe">{{ $t('summart_of_knowledge_test.describe') }}</p>
      <div class="article-list">
        <div
          v-for=" (article, index) in articleList"
          :key="index"
          class="article"
          @click="openNewTab(article.url)"
        >
          <div class="left">
            <img
              v-if="$i18n.locale === 'th'"
              src="/static/svg/icon-pdf-know.svg"
            >
            <img
              v-else
              src="/static/svg/icon-knowledge-test.svg"
            >
          </div>
          <div class="right">
            <span class="text">
              {{ $t(`summart_of_knowledge_test.${article.articleKey}`) }}
            </span>
            <img
              src="/static/svg/arrow-forward.svg"
              class="ic-arrow"
            >
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!isSubmitSuitabilityTest"
      class="section-white"
    >
      <div class="invite-suit-test--container">
        <div class="invite-suit-test--text">
          <p class="invite-suit-test--title">{{ $t('summart_of_knowledge_test.invite_suite_test.title') }}</p>
          <p class="invite-suit-test--describe">{{ $t('summart_of_knowledge_test.invite_suite_test.describe') }}</p>
          <div
            class="suit-test-btn"
            @click="$router.push({ name: 'SuitabilityTest' })"
          >
            {{ $t('summart_of_knowledge_test.invite_suite_test.text_btn') }}
          </div>
        </div>
        <div class="invite-suit-test--image">
          <img src="/static/img/suit-invite.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryOfKnowledgeTest',
  props: {
    knowledgeTestPoint: {
      type: Number,
      default: 0
    },
    isSubmitSuitabilityTest: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      articleListInThai: [
        { articleKey: 'article_1', url: 'https://investment-knowledge-documents.s3-ap-southeast-1.amazonaws.com/world+of+digital+asset.pdf' },
        { articleKey: 'article_2', url: 'https://investment-knowledge-documents.s3-ap-southeast-1.amazonaws.com/eco+system+of+digital+asset.pdf' },
        { articleKey: 'article_3', url: 'https://investment-knowledge-documents.s3-ap-southeast-1.amazonaws.com/basic+of+digital+asset+investment.pdf' },
        { articleKey: 'article_4', url: 'https://investment-knowledge-documents.s3-ap-southeast-1.amazonaws.com/Service+Form.pdf' },
        { articleKey: 'article_5', url: 'https://investment-knowledge-documents.s3.ap-southeast-1.amazonaws.com/Market%20Manipulations.pdf' },
        { articleKey: 'article_6', url: 'https://investment-knowledge-documents.s3.ap-southeast-1.amazonaws.com/Appendix.pdf' }
      ],
      articleListInEnglish: [
        { articleKey: 'article_1', url: 'https://www.youtube.com/watch?v=EohOm_qqVE4' },
        { articleKey: 'article_2', url: 'https://www.youtube.com/watch?v=KHW5VrHNymQ' },
        { articleKey: 'article_3', url: 'https://www.youtube.com/watch?v=nJjn48EQh2A' },
        { articleKey: 'article_4', url: 'https://www.youtube.com/watch?v=GjQPw3xbM5E' },
        { articleKey: 'article_5', url: 'https://www.youtube.com/watch?v=o9y2Iu0q7jI' },
        { articleKey: 'article_6', url: 'https://www.youtube.com/watch?v=xr1a1L-2KPo' }
      ]
    }
  },
  computed: {
    articleList () {
      return this.$i18n.locale === 'th' ? this.articleListInThai : this.articleListInEnglish
    }
  },
  methods: {
    openNewTab (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.knowledge-test-title {
  margin: 35px 0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #000000;
}
.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  font-size: 18px;
  line-height: 1.44;
  &:last-child {
    margin-top: 48px;
  }
}
.image-wrapper {
  display: block;
  text-align: center;
  img {
    width: 364px;
  }
}
.risk-point {
  font-size: 20px;
  text-align: center;
  margin: 40px 0 36px 0;
}
.describe {
  font-size: 17px;
  text-align: center;
}
.article-list {
  margin: 20px 0;
}
.article {
  padding: 14px 32px;
  min-height: 80px;
  display: flex;
  align-items: center;
  height: 2px;
  border-bottom: solid 1px #e4e4e4;
  cursor: pointer;
  .left {
    float: left;
    margin-right: 20px;
    img {
      width: 26px;
    }
  }
  .right {
    float: left;
    width: 100%;
    .text {
      font-size: 16px;
      float: left;
      width: 85%;
    }
    .ic-arrow {
      float: right;
    }
  }
  &:hover {
    background-color: #f3f3f3;
  }
}
.invite-suit-test {
  &--container {
    display: inline-block;
    position: relative;
    width: 100%;
  }
  &--title {
    font-size: 20px;
    font-weight: bold;
  }
  &--describe {
    font-size: 15px;
    margin: 30px 0;
  }
  &--text {
    float: left;
    width: 60%
  }
  &--image {
    position: absolute;
    right: -35px;
    width: 343px;
    bottom: -44px;
  }
}
.suit-test-btn {
  width: 323px;
  height: 45px;
  border-radius: 3px;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  background-color: #2193ff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  text-align: center;
  color: #ffffff;
  padding: 13px 0px;
  cursor: pointer;
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .section-white {
    width: calc(100% - 20px);
    padding: 30px 15px;
    &:last-child {
      margin-top: 20px;
    }
  }
  .article-list {
    margin: 30px 0;
  }
  .article {
    padding: 8px 0;
    height: 100%;
    .right {
      .text {
        width: 100%
      }
      .ic-arrow {
        display: none;
      }
    }
  }
  .invite-suit-test {
    &--text {
      width: 100%
    }
    &--image {
      display: none;
    }
  }
  .suit-test-btn {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SummaryOfKnowledgeTest.vue